import { atom } from "jotai"
import { GrowthHackingState } from "@/utils/dataTypes"
import { SOL_RESERVE_ITEM, SUPPLY } from "@/utils/constants"

export const appGrowthHackingSupplyWithdrawPopupState = atom<GrowthHackingState>({
  isOpen: false,
  type: SUPPLY,
  tokenName: SOL_RESERVE_ITEM.name,
})
